import React, { useEffect } from 'react';
import Header from '../components/landing/Header';
import HeroSection from '../components/landing/HeroSection';
import ProblemSection from '../components/landing/ProblemSection';
import CaptureConnectReuseSection from '../components/landing/CaptureConnectReuseSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import BeforeAfterSection from '../components/landing/BeforeAfterSection';
import CrossProjectSection from '../components/landing/CrossProjectSection';
import WhoItsForSection from '../components/landing/WhoItsForSection';
import FounderStorySection from '../components/landing/FounderStorySection';
import CTASection from '../components/landing/CTASection';
import InsightsSection from '../components/landing/InsightsSection';
import FAQSection from '../components/landing/FAQSection';
import Footer from '../components/landing/Footer';
import { setCanonical } from '../lib/seo';

const LandingPage = () => {
  useEffect(() => {
    setCanonical('/');
    fetch(`/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: window.location.pathname,
        referrer: document.referrer || null,
      }),
    }).catch(() => {});
  }, []);

  return (
    <div className="relative min-h-screen bg-[#FDF8F3]" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
      <Header />
      <main>
        <HeroSection />
        <ProblemSection />
        <CaptureConnectReuseSection />
        <HowItWorksSection />
        <BeforeAfterSection />
        <CrossProjectSection />
        <WhoItsForSection />
        <InsightsSection />
        <section className="bg-[#F5EFE6] border-y border-[#EAE1D3]/70 py-5" data-testid="home-demo-band">
          <div className="content-container flex flex-col sm:flex-row items-center justify-between gap-5 text-center sm:text-left">
            <p className="text-[#3D3A36] text-[17px] md:text-[19px]" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
              See it work, on a real email thread.
            </p>
            <a href="/how-it-works#demo" className="inline-flex items-center gap-2 bg-[#1F1812] text-white text-[14px] font-medium px-6 py-3 rounded-lg hover:bg-[#0F0D0A] transition-colors whitespace-nowrap">
              Watch Archen™ read a real thread
            </a>
          </div>
        </section>
        <FAQSection />
        <FounderStorySection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
